import Vue from 'vue'
import App from './App.vue'

import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/pro-solid-svg-icons'
import {far} from '@fortawesome/pro-regular-svg-icons'
import {fal} from '@fortawesome/pro-light-svg-icons'
import {fad} from '@fortawesome/pro-duotone-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import ApiClient from "./utils/ApiClient";
import BaseApiUrl from "./constants/BaseApiUrl";
import MessageService from "./services/MessageService";
import 'vue-good-table/dist/vue-good-table.css';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import 'material-icons/iconfont/material-icons.scss';
import VueGoodTablePlugin from 'vue-good-table';
import VueMaterial from 'vue-material'
import VueVirtualScrollList from 'vue-virtual-scroll-list'
import UserService from "./services/UserService";
import UserStore from "./stores/UserStore";
import Toasted from 'vue-toasted';
import 'vue-toasted/dist/vue-toasted.min.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

library.add(fas, far, fal, fad);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// @ts-ignore
Vue.use(VueGoodTablePlugin);
// @ts-ignore
Vue.use(VueMaterial);
// @ts-ignore
const MdBottomBar = Vue.options.components["MdBottomBar"].extend({
  watch: {
    mdActiveItem() {
      // @ts-ignore
      this.MdBottomBar.activeItem = this.mdActiveItem;
    }
  }
});
Vue.component(MdBottomBar.name, MdBottomBar);
// @ts-ignore
Vue.options.components["MdBottomBar"] = MdBottomBar;
// @ts-ignore
Vue.component('virtual-list', VueVirtualScrollList);

Vue.use(Toasted);
Vue.component('multi-select', Multiselect);
const apiClient = new ApiClient(BaseApiUrl);
const provide = {
  apiClient,
  messageService: new MessageService(apiClient),
  userService: new UserService(apiClient),
  userStore: new UserStore()
};

new Vue({
  provide,
  render: h => h(App),
}).$mount('#app');
